<!--空间访问权限解释说明tips-->
<template>
  <el-tooltip effect="dark" :content="text" placement="right">
    <i class="el-icon-question" v-show="text" :style="tipsColor"></i>
  </el-tooltip>
</template>

<script>
    export default {
        name: "SpaceAccessAuthTip",
        props: {
            /**
             * 监控值
             */
            value: {
                type: String,
                required: true,
            },
            /**
             * 定义监控值规则
             * {
             *   '[监控值]': {text: '[描述]', tipsType: '[tips颜色类型]'}
             * }
             * tipsType '1'是灰色、'2'是橘色、'3'是红色
             */
            valuesRule: {
                type: Object,
                required: true
            },
        },
        computed: {
            currRule: function() {
                return this.valuesRule[this.value];
            },
            /**
             * 计算当前提示提示文字
             */
            text: function () {
                return this.currRule && this.currRule.text ? this.currRule.text : '';
            },
            /**
             * 计算当前提示颜色，默认橘色
             */
            tipsColor: function () {
                let t = this.currRule && this.currRule.tipsType ? this.currRule.tipsType : '';
                switch (t) {
                    case '1':
                        return {'color': '#909399'};
                    case '3':
                        return {'color': '#F56C6C'};
                    default:
                        return {'color': '#E6A23C'};
                }

            }
        }
    }
</script>

<style scoped>
    i {
      font-size: 16px;
      cursor: pointer;
      vertical-align: text-bottom;
    }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/SpaceAccessAuthTip.vue